module.exports = __webpack_public_path__ + "img/12454-KCMA tm.61a340b6.png";